export default "__VITE_ASSET__CLLEIEIY__"